/** Using Duck style Actions Architecture. See https://github.com/erikras/ducks-modular-redux */

import axios from 'axios';

import { jelTypes } from '../constants';
import { generateFilter } from '../utils';

const PREFIX = 'jels/'
const ADD_JEL = PREFIX + 'ADD_JEL';
const SET_JELS = PREFIX + 'SET_JELS';
const DELETE_JEL = PREFIX + 'DELETE_JEL';
const SET_DEFAULT_JELS = PREFIX + 'SET_DEFAULT_JELS';
const SET_JELS_BY_VIEW = PREFIX + 'SET_JELS_BY_VIEW';

const initialState = {
  forms: [],
  tables: [],
  jelData: {},
  dashboards: [],
  userMenus: [],
  defaultForms: [],
};

export default function jelsReducer(state = initialState, action = {}) {
  switch (action.type) {

    case SET_JELS: {
      return {
        ...action.jels,
      };
    }

    case SET_DEFAULT_JELS: {
      const defaultForms = [ ...action.defaultForms ];
      return {
        ...state,
        defaultForms,
      };
    }

    case SET_JELS_BY_VIEW: {
      const { jels } = action;
      const { forms, jelData, tables } = jels;

      const newJelData = {
        ...state.jelData,
        ...jelData,
      };

      const newForms = [...new Set([
        ...state.forms,
        ...forms,
      ])];

      const newTables = [...new Set([
        ...state.tables,
        ...tables,
      ])];

      return {
        ...state,
        forms: newForms,
        tables: newTables,
        jelData: newJelData
      };
    }

    case ADD_JEL: {
      const { jelType, jel } = action;

      const newJelsIdsArray = [...state[jelType], jel.id];

      const newJelData = {
        ...state.jelData,
        [jel.id]: { ...jel }
      }
      
      return {
        ...state,
        [jelType]: newJelsIdsArray,
        jelData: newJelData
      };
    }

    case DELETE_JEL: {
      const { jelId, jelType } = action;

      const {
        [jelId]: deletedJel,
        ...jelDataWithoutJel
      } = state.jelData;

      const newJelsIdsArray = state[jelType].filter(id => id !== jelId);
      
      return {
        ...state,
        [jelType]: newJelsIdsArray,
        jelData: jelDataWithoutJel
      };
    }

    default: {
      return state;
    }
  }
}

export const setJels = (jels) => {
  return {
    type: SET_JELS,
    jels: jels,
  };
};

export const setJelsByView = (jels) => {
  return {
    type: SET_JELS_BY_VIEW,
    jels: jels,
  };
};

export const setDefaultJels = (def_frms) => {
  return {
    type: SET_DEFAULT_JELS,
    defaultForms: def_frms,
  };
};

export const addJel = (jel, jelType) => {
  return {
    type: ADD_JEL,
    jel,
    jelType,
  };
};

export const deleteJel = (jelId, jelType) => {
  return {
    type: DELETE_JEL,
    jelId,
    jelType,
  };
};

const convertOldFiltersToNewFormat = table => {
  const trpl_filter = table.trpl_filter;

  const isNewFiltersFormat = !trpl_filter || Array.isArray(trpl_filter)
  if (isNewFiltersFormat) {
    return table;
  }

  const fromEntryToFilter = ([filterRstIdTitle, filter]) => {
    if (typeof filter !== 'object') {
      // Old filter is a plain value: ["370.367", "false"]
      return generateFilter(filterRstIdTitle, filter);
    }

    // Old filter is an object: ["370.367", {"val": "1600","op": ">"}]
    const { val, op } = filter;
    return generateFilter(filterRstIdTitle, val, null, op)
  }

  const filtersArray = Object.entries(trpl_filter).map(fromEntryToFilter)

  return { ...table, trpl_filter: filtersArray };
};

export const collectJelsFromGetView = (jels) => {
  const frmsArr = [];
  const tblsArr = [];
  const tables = [];
  const forms = [];
  
  const jelData = {};

  Object.values(jels).forEach(jel => {
    if (jel.type === 'form') {
      frmsArr.push(jel);
    } else if (jel.type === 'table') {
      tblsArr.push(jel);
    }
  });


  tblsArr.forEach((tbl) => {
    tables.push(+tbl.id);

    jelData[tbl.id] = { ...convertOldFiltersToNewFormat(tbl), type: jelTypes.table };
  });

  frmsArr.forEach((frm) => {
    forms.push(+frm.id);

    jelData[frm.id] = { ...frm, type: jelTypes.form };
  });

  return {
    tables,
    forms,
    jelData,
  };
};

export const collectJels = (data) => {
  const flows = data.flow || [];
  const tblsArr = data.trpls_tbl || [];
  const frmsArr = data.trpls_frm || [];
  const userMenusArr = data.user_menu || [];
  const dashboardsArr = data.dashboard || [];
  const importedJels = data.imported || [];
  const defaultForms = data.def_frms || [];

  const jelData = {};

  const tables = [];
  const forms = [];
  const dashboards = [];
  const userMenus = [];

  const importedTables = [];
  const importedForms = [];
  const importedDashboards = [];

  importedJels.forEach(importedApp => {
    if (importedApp.trpls_frm) {
      importedApp.trpls_frm.forEach(frm => {
        forms.push(+frm.id);
        importedForms.push(+frm.id);

        jelData[frm.id] = { ...frm, type: jelTypes.form };
      })
    }

    if (importedApp.trpls_tbl) {
      importedApp.trpls_tbl.forEach(tbl => {
        tables.push(+tbl.id);
        importedTables.push(+tbl.id);

        jelData[tbl.id] = { ...tbl, type: jelTypes.table };
      })
    }

    if (importedApp.dashboard) {
      importedApp.dashboard.forEach(dashboard => {
        dashboards.push(+dashboard.id);
        importedDashboards.push(+dashboard.id);

        jelData[dashboard.id] = { ...dashboard, type: jelTypes.dashboard };
      })
    }
  });

  tblsArr.forEach((tbl) => {
    tables.push(+tbl.id);

    jelData[tbl.id] = { ...convertOldFiltersToNewFormat(tbl), type: jelTypes.table };
  });

  frmsArr.forEach((frm) => {
    forms.push(+frm.id);

    jelData[frm.id] = { ...frm, type: jelTypes.form };
  });

  dashboardsArr.forEach((dashboard) => {
    dashboards.push(+dashboard.id);

    jelData[dashboard.id] = { ...dashboard, type: jelTypes.dashboard };
  });

  userMenusArr.forEach((userMenu) => {
    userMenus.push(+userMenu.id);

    jelData[userMenu.id] = { ...userMenu, type: jelTypes.userMenu };
  });

  return {
    tables,
    forms,
    jelData,
    dashboards,
    defaultForms,
    importedJels,
    importedTables,
    importedDashboards,
    importedForms,
    userMenus,
    flows,
  };
};

export const updateJelsFromGetView = (data) => {
  return (dispatch) => {
    const jels = collectJelsFromGetView(data);

    dispatch(setJelsByView(jels));
  };
};

export const getJelData = (ids) => {
  return (dispatch) => {
    return axios
      .get(`/get_jel?ids=[${ids}]&recursive=true`)
      .then(({ data }) => {
        const jels = collectJelsFromGetView(data.jels);

        dispatch(setJelsByView(jels));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateJels = () => {
  return (dispatch) => {
    return axios
      .get('/get_jel?type=["trpls_tbl", "flow", "trpls_frm", "dashboard", "user_menu", "def_frms"]')
      .then(({ data }) => {
        const jels = collectJels(data);

        dispatch(setJels(jels));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateJelsSimple = () => {
  return (dispatch) => {
    return axios
      .get('/get_jel?type=["trpls_tbl", "trpls_frm", "dashboard", "def_frms"]')
      .then(({ data }) => {
        const jels = collectJels(data);

        dispatch(setJels(jels));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
